import { MenuNavBase } from "./MenuNavBase";
import { MenuNavUtils } from "./MenuNavUtils";

export class MenuNavHandlers extends MenuNavBase {

  constructor() {
    super();
  }

  onBackgroundPointerdown(event) {
    if (!this.domNode.contains(event.target)) {
      this.closePopupAll();
    }
  }

  onMenuitemClick(event) {
    var tgt = event.currentTarget;

    if (MenuNavUtils.hasPopup(tgt) && !MenuNavUtils.isInFullContentView(tgt)) {
      if (MenuNavUtils.isOpen(tgt) && MenuNavUtils.isTopLevel(tgt)) {
          this.closePopup(tgt);
      } else {
        this.closePopupAll(tgt);
        this.openPopup(tgt);
      }
    } else if(MenuNavUtils.hasLink(tgt)) {
      this.closePopupAll();
      // should navigate to the appropriate URL in anchor tag
      return;
    }
    event.stopPropagation();
    event.preventDefault();
  }

}
